export default __webpack_public_path__ + "static/media/rl-2-lqMAX.460c3e86.jpg";